export const UPDATE_HOME_LOCALE_DESCRIPTION = 'UPDATE_HOME_LOCALE_DESCRIPTION';

export function updateHomeLocaleDescription(locale) {
    return {
        type: UPDATE_HOME_LOCALE_DESCRIPTION,
        payload: locale
    };
}
